var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{class:[
    'layout-header',
    'panel',
    _vm.layoutClasses,
    { 'is-extra-button': _vm.isAuth }
]},[_c('div',{staticClass:"wrapper flex element-relative"},[_c('LogoDefault'),_c('NavigationInfo'),(_vm.isAuth)?_c('ButtonSignout',{nativeOn:{"click":function($event){return _vm.onClickSignout.apply(null, arguments)}}}):_vm._e()],1)])}
var staticRenderFns = []

export { render, staticRenderFns }